export default "__VITE_ASSET__c62hc57L__"